import React, { useCallback, useEffect, useMemo, useState } from 'react';
import HeadTitle from '../../components/HeadTitle';
import SearchFilter from '../../components/analytics-and-insights/SearchFilter';
import { useSelector } from 'react-redux';
import {
  fetchUsersList,
  fetchVerificationData,
} from '../../api/user';
import QueryTable from './QueryTable';

const QueryTicketManagement = () => {
  // Selectors: get filter object and the primitive searchTerm directly
  const filter = useSelector((state) => state.filter);
  const searchTermFromStore = useSelector((state) => state.filter.searchTerm);
  // Normalize searchTerm (convert null/undefined to empty string)
  const normalizedSearchTermFromStore = searchTermFromStore ?? '';
  const filterWithoutUTM = useMemo(() => {
    const { utm_options, ...rest } = filter || {};
    return rest;
  }, [JSON.stringify(filter)]);
  const [verificationData, setVerificationData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [pageLimit, setPageLimit] = useState(25);
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState(normalizedSearchTermFromStore);
  // useEffect(() => {
  //   if ((searchTerm ?? '') !== normalizedSearchTermFromStore) {
  //     setSearchTerm(normalizedSearchTermFromStore);
  //     setCurrentPage(1); 
  //   }
  // }, [normalizedSearchTermFromStore]);
  // const fetchData = useCallback(async (signal) => {
  //   try {
  //     setLoading(true);
  //     await fetchVerificationData(filter || {}, setVerificationData);
  //     const data = await fetchUsersList({
  //       filter,
  //       setUserData: () => {},
  //       page: currentPage,
  //       limit: pageLimit,
  //       skip: 0,
  //       verification: true,
  //       searchTerm: searchTerm ?? '',
  //       signal, // pass signal if your api supports it
  //     });
  //     if (data) {
  //       setTotalUsers(data.totalUsersCount ?? data.total ?? 0);
  //       setTotalPages(data.totalPages ?? 0);
  //     }
  //   } catch (error) {
  //     // ignore abort errors
  //     if (error?.name !== 'AbortError') {
  //       console.error('Error while loading data', error);
  //     }
  //   } finally {
  //     setLoading(false);
  //   }
  // }, [filterWithoutUTM, currentPage, pageLimit, searchTerm]);

  // useEffect(() => {
  //   const controller = new AbortController();
  //   fetchData(controller.signal);
  //   return () => controller.abort();
  // }, [fetchData]);

  // Components meta - unchanged
  const components = [
    {
      id: 1,
      imageSrc: '/assets/images/admin-panel/query-ticket-management/query-ticket.svg',
      text: 'Query Ticket Management ',
      description: 'Track, prioritize, and resolve user queries efficiently.',
    },
  ];

  return (
    <div>
      {components.map((component) => (
        <HeadTitle
          key={component.id}
          imageSrc={component.imageSrc}
          text={component.text}
          description={component.description}
        />
      ))}

      <SearchFilter
        isHideUserManagement={false}
        isHideSelectCam={false}
      />

      <QueryTable
        searchTerm={searchTerm}
        setSearchTerm={(val) => {
          setSearchTerm(val ?? '');
          setCurrentPage(1);
        }}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        pageLimit={pageLimit}
        setPageLimit={setPageLimit}
        filter={filter}
        loading={loading}
        verificationData={verificationData}
        totalUsers={totalUsers}
        totalPages={totalPages}
        fetchParentData={() => {
          // const controller = new AbortController();
          // fetchData(controller.signal);
        }}
      />
    </div>
  );
};

export default QueryTicketManagement;
